import React from "react";
import PropTypes from "prop-types";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdCheckCircle, MdErrorOutline, MdWarningAmber } from "react-icons/md";

const variantStyles = {
  info: {
    bg: "alertbox-bg-info",
    iconClass: "alertbox-icon-info",
    Icon: AiOutlineInfoCircle,
  },
  success: {
    bg: "alertbox-bg-success",
    iconClass: "alertbox-icon-success",
    Icon: MdCheckCircle,
  },
  warning: {
    bg: "alertbox-bg-warning",
    iconClass: "alertbox-icon-warning",
    Icon: MdWarningAmber,
  },
  error: {
    bg: "alertbox-bg-error",
    iconClass: "alertbox-icon-error",
    Icon: MdErrorOutline,
  },
};

const VmoAlertBox = ({
  header,
  type = "info",
  className = "",
  children,
  ...rest
}) => {
  const { bg, iconClass, Icon } = variantStyles[type] || variantStyles["info"];

  return (
    <div className={`alertbox ${bg} ${className}`} {...rest}>
      <div className="alertbox__top">
        <Icon className={`alertbox-icon ${iconClass}`} />
        <div className="alertbox__header">{header}</div>
      </div>
      <div className="alertbox__content">{children}</div>
    </div>
  );
};

export default VmoAlertBox;

VmoAlertBox.propTypes = {
  header: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),
  classNames: PropTypes.string,
  children: PropTypes.node.isRequired,
};
